import { useMutation, useQuery } from "react-query";
import { getReservation, getReservationsByDate, getReservationsByMonth, getReservationsCountByMonth, postReservation } from "./requests";
import { notifyError, notifySuccess } from "@/toast-notifications";
import store from '@/store/configureStore';
import { ADD_RESERVATION_SUCCESS as ADD_RESERVATION_SUCCESS_MSG } from "@/successes";
import { ADD_RESERVATION_ERROR, ADD_RESERVATION_ERROR as ADD_RESERVATION_ERROR_MSG } from "@/errors";
import { ADD_RESERVATION_SUCCESS } from "@/store/actions/reservations";
import useFetchQuery from "@/hooks/useFetchQuery";

export const RESERVATIONS_KEY = "reservations";

export const buildReservationQueryKey = (id) => [RESERVATIONS_KEY, id];

export const useGetReservation = (id, options = {}) =>
    useQuery({
        ...options,
        queryKey: buildReservationQueryKey(id),
        queryFn: () => getReservation(id),
        onError: () => {
            notifyError("Une erreur est survenue lors de la récupération de la réservation.");
        },
    });

export const useFetchGetReservation = () =>
    useFetchQuery(
        (_context, args) => getReservation(...args),
        buildReservationQueryKey,
        {
            onError: () => {
                notifyError("Une erreur est survenue lors de la récupération de la réservation.");
            }
        }
    );

export const useGetReservationsByDate = (date, options = {}) =>
    useQuery(
        [RESERVATIONS_KEY, 'list', { date }], 
        () => getReservationsByDate(date),
        { 
            ...options,
            onError: () => {
                notifyError("Une erreur est survenue lors de la récupération des anciennes réservations.");
            }, 
        },
    );

export const useGetReservationsByMonth = (month, year, options = {}) =>
    useQuery(
        [RESERVATIONS_KEY, 'list', { month, year }], 
        () => getReservationsByMonth(month, year),
        { 
            ...options,
            staleTime: Infinity,
            cacheTime: Infinity,
            onError: () => {
                notifyError("Une erreur est survenue lors de la récupération des anciennes réservations.");
            }, 
        },
    );


export const RESERVATIONS_COUNTS_KEY = "reservations-counts";

export const useGetReservationsCountByMonth = (month, year, options = {}) =>
    useQuery(
        [RESERVATIONS_COUNTS_KEY, 'list', { month, year }], 
        () => getReservationsCountByMonth(month, year),
        { 
            ...options,
            staleTime: Infinity,
            cacheTime: Infinity,
            onError: () => {
                notifyError("Une erreur est survenue lors de la récupération du compte des réservations.");
            }, 
        },
    );


export const usePostReservation = (options = {}) => 
    useMutation(
        postReservation,
        {
            ...options,
            onSuccess: (reservation) => {
                store.dispatch({ type: ADD_RESERVATION_SUCCESS, reservation, loading: false, error: null, });
                notifySuccess(ADD_RESERVATION_SUCCESS_MSG);
            },
            onError: (error) => {
                store.dispatch({ type: ADD_RESERVATION_ERROR, loading: false, error, });
                notifyError(ADD_RESERVATION_ERROR_MSG);
            }
        }
    );


// WEBPACK FOOTER //
// ./src/queries/reservations/hooks.js